<template>
    <div class="sidebar">
        <el-menu :collapse="false" :default-active="activeTabId" class="el-menu-vertical-demo" unique-opened>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.tab_id">
                        <template slot="title">
                            <i :class="item.icon" :style="{color: item.icon_color}" class="el-st"></i>
                            <span style="margin-left: 10px">{{ item.name }}</span>
                        </template>
                        <el-menu-item v-for="(subItem, i) in item.subs" :key="i" :index="subItem.tab_id"
                                      @click="handleClick(subItem.tab_id,subItem.url)">
                            {{ subItem.name }}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.tab_id" @click="handleClick(item.tab_id,item.url)">
                        <i :class="item.icon" :style="{color: item.icon_color}"></i>{{ item.name }}
                    </el-menu-item>
                </template>
            </template>
        </el-menu>

        <el-dialog title="重新登录" :visible.sync="relogin" width="30%" size="mini" :close-on-click-modal="false" center>
            <el-form size="small" :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="username" label="用户名：" label-width="100px">
                    <el-input v-model="ruleForm.username" class="dialog-input"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码：" label-width="100px">
                    <el-input type="password" v-model="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')"
                              class="dialog-input"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="relogin = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeTabId: "home",
                items: [
                    {
                        tab_id: "home",
                        name: "首页",
                        icon: "el-icon-s-home",
                        icon_color: "#aeb9c2",
                        url: ""
                    },
                    {
                        tab_id: "goods",
                        name: "商品管理",
                        icon: "el-icon-s-shop",
                        icon_color: "#aeb9c2",
                        url: "goods/Index"
                    },
                    {
                        tab_id: "xpqd",
                        name: "询盘清单",
                        icon: "el-icon-document",
                        icon_color: "#aeb9c2",
                        url: "page/xpqd/Index"
                    },
                    {
                        tab_id: "decoration",
                        name: "主页装修",
                        icon: "el-icon-picture-outline",
                        icon_color: "#aeb9c2",
                        url: "page/decoration/Index"
                    },
                    {
                        tab_id: "business",
                        name: "账户信息",
                        icon: "el-icon-setting",
                        icon_color: "#aeb9c2",
                        url: "",
                        subs: [
                            {
                                tab_id: "business_company",
                                name: "企业信息",
                                icon: "",
                                icon_color: "",
                                url: "business/company",
                            },
                            {
                                tab_id: "business_person",
                                name: "个人信息",
                                icon: "",
                                icon_color: "",
                                url: "business/person",
                            },
//                            {
//                                tab_id: "business_wechat",
//                                name: "微信绑定",
//                                icon: "",
//                                icon_color: "",
//                                url: "business/wechat",
//                            },
                        ]
                    },
                ],
                ruleForm: {
                    username: "",
                    password: ""
                },
                rules: {
                    username: [
                        {
                            required: true,
                            message: "请输入用户名",
                            trigger: "blur"
                        },
                        {
                            min: 3,
                            message: "用户名必须大于3位",
                            trigger: "blur,change"
                        }
                    ],
                    password: [
                        {required: true, message: "请输入密码", trigger: "blur"},
                        {
                            min: 6,
                            message: "密码必须大于6位",
                            trigger: "blur,change"
                        }
                    ]
                }
            };
        },
        computed: {
            relogin: {
                get() {
                    return this.$store.state.pagePassValue.relogin;
                },
                set(value) {
                    this.$store.commit("pagePassValue/setRelogin", value);
                }
            },
        },
        methods: {
            handleClick(tab_id, url){
                this.activeTabId = tab_id
                if (url !== '') {
                    this.$router.push('/index/' + url)
                }else{
                    this.$router.push('/index')
                }
            },
            submitForm(formName) {
                const self = this;
                self.$refs[formName].validate(valid => {
                    if (valid) {
                        self.$ajax
                            .post("/admin/Login/login", self.ruleForm)
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    localStorage.setItem(
                                        "org_user_name",
                                        res.data.data
                                    );
                                    location.replace("/index.html");
                                    self.relogin = false;
                                } else {
                                    self.$message.error(res.data.message);
                                }
                            })
                            .catch(function (err) {
                                self.$message("网络错误！请联系管理员");
                            });
                    } else {
                        return false;
                    }
                });
            },
        },
        created() {
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/admin/home/Sidebar.vue